import { render, staticRenderFns } from "./TerminosPagador.vue?vue&type=template&id=cec5888c"
import script from "./TerminosPagador.vue?vue&type=script&lang=js"
export * from "./TerminosPagador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports